import type { AxiosError } from 'axios';

// NOTE: In some cases on v2, we do not have `axios.isAxiosError`
// because in `medusa @fiverr-private/vendors-5rr@1.3.4`,
// `axios@0.19.2` is installed as a dependency.
export function isAxiosError(payload: unknown): payload is AxiosError {
    return (
        !!payload && typeof payload === 'object' && 'isAxiosError' in payload && (payload as AxiosError).isAxiosError
    );
}
